import React from "react";
import styled, { css } from "styled-components";
import Section from "@cs/components/src/Section";
import Table from "@cs/components/src/Table";
import ComponentTypeBadge from "./ComponentTypeBadge";
// import { newVariable } from './utils';

interface Props {
  value: VariableConfig[];
  onChange: (value: VariableConfig[]) => void;
  title: React.ReactNode;
}

interface RowProps {
  variable: VariableConfig;
  onRemove: () => void;
}

const grid = ["1fr", "130px", "1fr", "30px"];

const StyledRow = styled.div`
  display: grid;
  grid-template-columns: ${grid.join(" ")};
  column-gap: 10px;
  align-items: center;
`;

const Title = styled.span<{ $empty?: boolean }>`
  ${(props) =>
    props.$empty &&
    css`
      color: var(--gray200);
    `};
`;

const Required = styled.span`
  color: var(--gray200);
  padding-left: 5px;
`;

const VariableRow = (props: RowProps) => {
  const { variable } = props;

  return (
    <StyledRow>
      <Title $empty={!variable.title}>
        {variable.title || "Unnamed variable"}
      </Title>
      {variable.dataType !== "__separator__" ? (
        <>
          <div>
            <ComponentTypeBadge type={"variable_config"} />
          </div>
          <span>
            <span>{variable.key}</span>
            {variable.required && <Required>(Required)</Required>}
          </span>
        </>
      ) : (
        <>
          <span />
          <span />
        </>
      )}

      {/* <Button
        icon={X}
        iconSize={19}
        type="danger"
        borderless
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          onRemove();
        }}
      /> */}
    </StyledRow>
  );
};

const VariableTable = (props: Props) => {
  const { value: variables, onChange, title } = props;

  return (
    <Section
      title={title}
      // buttons={
      //   <Button
      //     icon={Plus}
      //     iconSize={19}
      //     onClick={() => {
      //       const variable = newVariable();
      //       const id = variable.id;
      //       onChange([...variables, variable]);
      //       navigate(`variable/${id}`);
      //     }}
      //   />
      // }
    >
      <Table
        isSorting
        onSort={(from, to) => {
          const vars = [...variables];
          vars.splice(to, 0, vars.splice(from, 1)[0]);
          onChange(vars);
        }}
        rows={variables.map((variable) => ({
          id: variable.id ?? variable.key,
          link: `variable/${variable.id ?? variable.key}`,
          element: () => (
            <VariableRow
              variable={variable}
              onRemove={() => {
                const variableId = variable.id ?? variable.key;
                onChange(
                  variables.filter((v) => (v.id ?? v.key) !== variableId)
                );
              }}
            />
          ),
        }))}
        autoHeight={{ twoColumn: true }}
      />
    </Section>
  );
};

export default VariableTable;
